import { oc } from "@orpc/contract";
import { z } from "zod";

export const FieldFormatSchema = z.enum([
  "string",
  "currency",
  "currency4",
  "date",
  "number",
  "integer",
  "float",
]);

export const FieldSchemaEntrySchema = z.object({
  apiField: z.string(),
  label: z.string(),
  format: FieldFormatSchema,
});

export const GetFieldSchemaResponseSchema = z.object({
  fields: z.array(FieldSchemaEntrySchema),
});

export const e844sdFieldSchemaContracts = {
  getSchema: oc.input(z.object({})).output(GetFieldSchemaResponseSchema).route({
    summary: "Get 844 claim transaction field schema",
    description:
      "Returns the available 844 ship-and-debit transaction fields with display labels and formats, used to build configurable claim table columns.",
    method: "GET",
  }),
} as const;

export type FieldSchemaEntry = z.infer<typeof FieldSchemaEntrySchema>;
export type GetFieldSchemaResponse = z.infer<
  typeof GetFieldSchemaResponseSchema
>;
